<div>
  <h4 style="font-size: 100%;
  font-weight: 700; margin-block-start: 1.33em;
margin-block-end: 1.33em;">{{header}}</h4>
</div>
<div style="display: flex; flex-direction: column;">
  @if (ctrlArray.length) {
    <form [formGroup]="formGroup">
      <div [formArrayName]="ctrlArrayName">
        @for (flag of flags; track flag; let i = $index) {
          <div style="display: flex; flex-direction: row; gap: 10px;">
            <div style="flex: 0 1 calc(75% - 10px);" class="property-header">
              <span>{{flag.displayName}}</span>
            </div>
            <div style="flex: 0 1 calc(25% - 10px); display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
              <mat-slide-toggle
                color="primary"
                class="example-margin hide-icon-keep-size"
                [formControlName]="i">
              </mat-slide-toggle>
            </div>
          </div>
        }
      </div>
    </form>
  }
</div>


 <!-- <mat-slide-toggle
                color="primary"
                class="example-margin hide-icon-keep-size"
                [formControlName]="i">
              </mat-slide-toggle> -->